import React from 'react'
import Select from 'react-select'
import { MediaImage, LevelsIcon } from '../../../../_components'
import styles from '../../styles.module.scss'

const selectDevicesValues = [
  { label: <div><i className="linearicons-laptop-phone" style={{marginRight: "15px"}}></i> Todos os dispositivos</div>, value: "devices_all" },
  { label: <div><i className="linearicons-smartphone"></i><i className="linearicons-tablet" style={{marginRight: "15px"}}></i> Somente dispositivos móveis</div>, value: "devices_mobile" },
  { label: <div><i className="linearicons-smartphone" style={{marginRight: "15px"}}></i> Somente smartphones</div>, value: "devices_smartphone" },
  { label: <div><i className="linearicons-tablet" style={{marginRight: "15px"}}></i> Somente tablets</div>, value: "devices_tablets" },
  { label: <div><i className="linearicons-desktop" style={{marginRight: "15px"}}></i> Somente desktops/laptops</div>, value: "devices_desktops" }
]

const webviewPositionOptions = [
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-topLeft"></span></i> Topo esquerda</div>, value: "topLeft" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-topCenter"></span></i> Topo centro</div>, value: "topCenter" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-topRight"></span></i> Topo direita</div>, value: "topRight" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-centerLeft"></span></i> Centro esquerda</div>, value: "centerLeft" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-centerCenter"></span></i> Centro</div>, value: "centerCenter" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-centerRight"></span></i> Centro direita</div>, value: "centerRight" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-bottomLeft"></span></i> Fundo esquerda</div>, value: "bottomLeft" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-bottomCenter"></span></i> Fundo centro</div>, value: "bottomCenter" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-bottomRight"></span></i> Fundo direita</div>, value: "bottomRight" },
]

const webviewTypes = {
  "alert_title": AlertTitle,
  "alert_image": AlertImage,
  "alert": Alert,
  "hoverbar": HoverBar
}

export default function Webview({localData, handleChange}) {
  return (<>
    <Select
      className="selectable"
      options={selectDevicesValues}
      onChange={e => handleChange(e, 'devices')}
      placeholder="Selecionar dispositivos a serem impactados"
      noOptionsMessage={() =>"Nenhuma opção disponível"}
      defaultValue={localData.raw_devices}
    />

    <div className="flex__break"></div>

    <Select
      className="selectable"
      options={[
        {label: "Box com título", value: "alert_title"},
        {label: "Box sem título", value: "alert"},
        {label: "Box com imagem", value: "alert_image"},
        {label: "Barra de notificação", value: "hoverbar"}
      ]}
      placeholder="Tipo de notificação"
      defaultValue={localData.raw_webview_type}
      onChange={e => handleChange(e, 'webview_type')}
    />

    {
      localData.raw_webview_type ? <>
        <div className="flex__break"></div>

        <div className={styles["card__sub-body"]}>
          <div className="flex">
            <div className="w-full">
              <div className={styles['title__group']}>
                <LevelsIcon />
                <h4>Customizar mensagem</h4>
              </div>

              <div className={styles['content__wrapper']}>
                {
                  (() => {
                    const Component = webviewTypes[localData.webview_type]
                    return <Component handleChange={handleChange}/>
                  })()
                }
              </div>
            </div>
          </div>
        </div>
      </> : null
    }
  </>)
}

function AlertTitle({handleChange}) {
  return(<>
    <div className="flex__break"></div>

    <div className={styles["input__group-wrapper"]}>
      <div className={styles["input__group"]}>
        <input type="text" className="inputable" placeholder="Título do Box" onChange={e => handleChange(e.target, 'webview_box_title')}/>
      </div>
      <div className={styles["input__group"]}>
        <Select
          className="selectable"
          options={webviewPositionOptions}
          placeholder="Posição do box"
          onChange={e => handleChange(e, 'webview_box_position')}
        />
      </div>
    </div>

    <div className="flex__break"></div>

    <div className={styles["input__group-wrapper"]}>
      <div className={styles['input__group']}>
        <textarea className="inputable" placeholder="Conteúdo do box" onChange={e => handleChange(e.target, 'webview_box_content')}/>
      </div>
    </div>
    
    
  </>)
}

function AlertImage({handleChange}) {
  return(
    <h1>Alert image</h1>
  )
}

function Alert({handleChange}) {
  return(
    <h1>Alert</h1>
  )
}

function HoverBar({handleChange}) {
  return(
    <h1>Hover bar</h1>
  )
}